module.exports = __webpack_public_path__ + "static/media/logo.776e034e.png";